import { Dispatch, SetStateAction, useState } from 'react';

import { AnalyticsReportSettingsProps } from '~/data/reports';
import {
  AnalyticsReportConfig,
  DefaultAnalyticsReportSettings,
} from '~/scenes/PortalModules/Analytics/common/ReportDatasetSelector/data';
import { useValidReportSettingOptions } from '~/scenes/PortalModules/Analytics/common/ReportDatasetSelector/useValidReportSettingOptions';
import { browserLogError } from '~/utils/helper';

export type UseReportDatasetProps<P> = DefaultAnalyticsReportSettings<P>;

export type UseReportDatasetOutput<P> = {
  reportEnabled: boolean;
  reportSelection: AnalyticsReportSettingsProps<P>;
  setReportSelection: Dispatch<SetStateAction<AnalyticsReportSettingsProps<P>>>;
  reportConfig: AnalyticsReportConfig;
};

export const useReportDataset = <P>(
  props: UseReportDatasetProps<P>,
): UseReportDatasetOutput<P> => {
  const { selection: initialSelection, config } =
    useValidReportSettingOptions(props);

  const [reportSelection, setReportSelection] =
    useState<AnalyticsReportSettingsProps<P>>(initialSelection);

  const reportEnabled = config.options.types.length > 0;

  if (!reportEnabled) {
    browserLogError([
      'Report configuration issue: No report types available for user',
      '- Users roles & assigned responsibilities may be insufficient',
    ]);
  }

  return {
    reportEnabled,
    reportSelection,
    setReportSelection,
    reportConfig: config,
  };
};
